module.exports = __webpack_public_path__ + "static/media/st_details_import.26ae4656.svg";